const {
  hooks: { addFilter },
} = wp;
/**
 * Add extended settings globally to all our B3rg blocks.
 *
 * @param {Object} settings Current block settings.
 * @param {string} name     Name of block.
 *
 * @return {Object} Modified block settings.
 */
const addExtendedSettings = (settings, name) => {
  // Check if name starts with 'b3rg/'
  if (!name.startsWith('b3rg/')) {
    return settings;
  }

  const extendedSettings = {
    ...settings,
    supports: {
      ...settings.supports,
      renaming: false,
    },
  };
  return extendedSettings;
};

addFilter(
  'blocks.registerBlockType',
  'b3rg/add-extended-settings',
  addExtendedSettings,
);
